/**
 * AccountLayout — wrapper para las 3 sub-páginas de /cuenta.
 *
 * Renderiza AppShell + un sidebar secundario con 3 tabs:
 *   - Perfil personal   (/cuenta)
 *   - Seguridad         (/cuenta/seguridad)
 *   - Privacidad        (/cuenta/privacidad)
 *
 * Mantiene el AppShell global del facturador (mismo sidebar de
 * Facturas/Clientes/etc) — el secondary nav es nested para cuenta.
 */

import { NavLink } from 'react-router-dom'
import { Lock, Shield, User } from 'lucide-react'
import { AppShell } from '@/components/layout/app-shell'
import { ROUTES } from '@/lib/constants'

const TABS = [
  { to: ROUTES.ACCOUNT, label: 'Perfil', icon: User, end: true },
  { to: ROUTES.ACCOUNT_SECURITY, label: 'Seguridad', icon: Shield, end: false },
  { to: ROUTES.ACCOUNT_PRIVACY, label: 'Privacidad', icon: Lock, end: false },
]

export function AccountLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppShell>
      <div className="mx-auto max-w-4xl">
        <header>
          <h1 className="text-3xl font-bold">Mi cuenta</h1>
          <p className="mt-1 text-sm text-fg-secondary">
            Datos personales, seguridad y privacidad. La configuración fiscal
            de la empresa vive en <strong>Configuración</strong>.
          </p>
        </header>

        <nav className="mt-6 flex gap-1 border-b border-border">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-brand-500 text-fg-primary'
                    : 'border-transparent text-fg-secondary hover:text-fg-primary hover:border-border'
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-6">{children}</div>
      </div>
    </AppShell>
  )
}
